import React from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { useProgress } from "@/context/ProgressContext";
import { MODULES, FINAL_MODULE } from "@/data/modules";
import { ProgressBar } from "@/components/ui";

export default function Training() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const { countDone } = useProgress();

  const percentFor = (m) => (m.lessons.length === 0 ? 0 : Math.round((countDone(m.lessons.map((l) => l.id)) / m.lessons.length) * 100));

  const card = (m, index) => {
    const percent = percentFor(m);
    return (
      <button key={m.id} data-testid={`module-${m.id}`} className="pressable" onClick={() => navigate(`/module/${m.id}`)} style={{ width: "100%", display: "block", background: colors.surfaceSecondary, borderRadius: 20, border: `1px solid ${colors.border}`, padding: 18, marginBottom: 14, cursor: "pointer", textAlign: "left" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 28, height: 28, borderRadius: 10, background: colors.brandPrimary, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            {index !== null ? <span style={{ color: colors.onBrandPrimary, fontSize: 14, fontWeight: 800, fontFamily: fonts.text }}>{index}</span> : <Icon name="flag" size={16} color={colors.onBrandPrimary} />}
          </div>
          <span style={{ flex: 1, color: colors.onSurface, fontSize: 16, fontWeight: 700, fontFamily: fonts.text }}>{m.title}</span>
          <Icon name="chevron-right" size={20} color={colors.muted} />
        </div>
        <div style={{ color: colors.muted, fontSize: 13, marginTop: 6, marginLeft: 40, fontFamily: fonts.text }}>{m.subtitle}</div>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 14, marginLeft: 40 }}>
          <div style={{ flex: 1 }}><ProgressBar percent={percent} /></div>
          <span style={{ color: colors.success, fontSize: 13, fontWeight: 700, fontFamily: fonts.text }}>{percent}%</span>
        </div>
      </button>
    );
  };

  return (
    <div className="ritzy-fade">
      <div style={{ padding: "20px 24px 16px", borderBottom: `1px solid ${colors.divider}` }}>
        <div style={{ color: colors.onSurface, fontSize: 28, fontFamily: fonts.display, fontWeight: 700 }}>Training</div>
        <div style={{ color: colors.muted, fontSize: 13, marginTop: 4, fontFamily: fonts.text }}>Work through it at your own pace.</div>
      </div>
      <div style={{ padding: "20px 24px" }}>
        {MODULES.map((m, i) => card(m, i + 1))}
        <div style={{ color: colors.muted, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.5, margin: "10px 0 12px", fontFamily: fonts.text }}>Final step</div>
        {card(FINAL_MODULE, null)}

        <button data-testid="open-content-lab" className="pressable" onClick={() => navigate("/lab")} style={{ width: "100%", display: "block", background: colors.brand, borderRadius: 20, border: "none", padding: 18, marginTop: 18, cursor: "pointer", textAlign: "left" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ fontSize: 24 }}>🧪</span>
            <span style={{ background: "rgba(255,255,255,0.22)", borderRadius: 999, padding: "3px 10px", color: colors.onBrand, fontSize: 10, fontWeight: 800, letterSpacing: 0.5, fontFamily: fonts.text }}>OPTIONAL</span>
          </div>
          <div style={{ color: colors.onBrand, fontSize: 20, fontFamily: fonts.display, fontWeight: 700, marginTop: 10 }}>The Weirdo Content Lab</div>
          <div style={{ color: colors.onBrand, opacity: 0.92, fontSize: 13, lineHeight: "20px", marginTop: 6, fontFamily: fonts.text }}>Optional deeper social-media & content training. Make better content, find your voice, sell without sounding like a knob.</div>
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 14, color: colors.onBrand, fontSize: 14, fontWeight: 700, fontFamily: fonts.text }}>Open the Lab <Icon name="arrow-right" size={16} color={colors.onBrand} /></div>
        </button>
      </div>
    </div>
  );
}
